import React from 'react';
import { type WhiteboardSidePanelItem } from '../../sidepanel-types';
import TimerSidePanelComponent from './timer/SidePanelComponent';
import TimerSidePanelTab from './timer/TabComponent';
import VotingSessionSidePanelTab from './VotingSession/TabComponent';
import VotingSessionPanel from './VotingSession/Panel';
import { svgToIcon } from '../../utils/svg';
import votingIcon from '../../assets/icons/voting.svg';
import timerIcon from '../../assets/icons/timer.svg';

export const facilitationSidePanelItems: WhiteboardSidePanelItem[] = [
  {
    id: 'voting',
    name: 'Voting',
    icon: svgToIcon(votingIcon),
    alwaysRendered: true,
    promoLink: () =>
      !window.currentAccount?.whiteboardsAdvanced
        ? '/suite/whiteboards?upgrade_location=whiteboards_side_panel_voting'
        : undefined,
    hidden({ canFacilitate }) {
      return !canFacilitate;
    },
    tabContent: <VotingSessionSidePanelTab />,
    panel: <VotingSessionPanel />,
  },
  {
    id: 'timer',
    name: 'Timer',
    icon: svgToIcon(timerIcon),
    alwaysRendered: true,
    promoLink: () =>
      !window.currentAccount?.whiteboardsAdvanced
        ? '/suite/whiteboards?upgrade_location=whiteboards_side_panel_timer'
        : undefined,
    hidden({ canFacilitate }) {
      return !canFacilitate;
    },
    tabContent: <TimerSidePanelTab />,
    content: <TimerSidePanelComponent />,
  },
];
